<template>
  <div
    class="font-medium text-[17px] leading-[18px] text-gray-800 pb-6 border-b border-[#DFDFDF]"
  >
    Account management
  </div>

  <SettingsRow>
    <template #left><div>Delete account</div></template>

    <template #right>
      <button
        v-if="user"
        type="button"
        class="flex items-center cursor-pointer"
        @click="emit('delete')"
      >
        <AlertIcon class="size-[18px] text-red-700 mr-2" />
        <div class="font-medium text-red-700">Delete</div>
      </button>
      <Skeleton v-else class="w-[80px] h-[18px]" />
    </template>
  </SettingsRow>
</template>

<script setup lang="ts">
import SettingsRow from '@/features/settings/components/SettingsRow.vue'
import { Skeleton } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'
import type { UserFieldsFragment } from '@/shared/graphql/legacy/generated'

defineProps<{
  user: UserFieldsFragment | null
}>()

const emit = defineEmits<{
  (e: 'delete'): void
}>()
</script>
